<template>
  <div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <div class="row dashboard-border">
        <div class="col-md-2 col-5 align-self-center" >
          <img src="../assets/icons/project.png" height="35" width="35"/>
          <span class="mx-2" style="font-size: 18px;"> {{project.projectName}}  </span>
        </div>
        <div class="col-md-5 col-7">
          <ul class="nav nav-tabs" id="myTab" role="tablist" style="float:right;">
            <li class="nav-item" role="presentation">
              <button class="nav-link active"  id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Roles</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="user-tab" data-bs-toggle="tab" data-bs-target="#user-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Users</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" :class="{'active': isRed}" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">Permissions</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact-tab-pane" type="button" role="tab" aria-controls="contact-tab-pane" aria-selected="false">Users/Roles</button>
            </li>
          </ul>
        </div>
      </div>
      <div class="row card-text-style">
        <div class="tab-content mt-3" id="myTabContent">
          <div class="tab-pane fade" id="user-tab-pane" role="tabpanel" aria-labelledby="user-tab" tabindex="0">
            <user-list></user-list>
          </div>
          <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
            <div class="row gx-5" id="">
              <div class="col-4 p-0">
                <div class="alert alert-warning mb-2 card-hover" role="alert" style="box-shadow: rgb(206 212 218) 0px 3px 10px;border-radius: 8px;margin-left: 11px;min-height: 100%;" @click="makeRed">
                  <font-awesome-icon icon="exclamation-triangle" class="icon"/>
                  Atanmamış roller var.
                </div>
              </div>
              <div class="col-4 p-0">
                <div class="alert alert-warning mb-2 card-hover" role="alert" style="box-shadow: rgb(206 212 218) 0px 3px 10px;border-radius: 8px;margin-left: 11px;min-height: 100%;">
                  <font-awesome-icon icon="exclamation-triangle" class="icon"/>
                  Atanmamış permissionlar var.
                </div>
              </div>
              <div class="col-4 p-0">
                <div class="alert alert-warning mb-2 card-hover" role="alert" style="box-shadow: rgb(206 212 218) 0px 3px 10px;border-radius: 8px;margin-right: 11px;margin-left: 11px;min-height: 100%;">
                  <font-awesome-icon icon="exclamation-triangle" class="icon"/>
                  Atanmamış kullanıcılar var.
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" :class="{'active show': isRed}" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">
            <project-details ></project-details>
          </div>
          <div class="tab-pane fade" id="contact-tab-pane" role="tabpanel" aria-labelledby="contact-tab" tabindex="0">..DFSSSSDS.</div>
        </div>

        <!--
        <div class="col-md-6 col-12 p-0 col-lg-4">
          <div style="background: #FFFFFF;box-shadow:0px 3px 10px #ced4da;border-radius: 8px;margin-right: 15px;margin-left: 11px;" class="card-hover">
            <div class="row" style="padding: 10px">
              <div class="col-md-9 col-10">
                <span style="font-weight: 500; font-size: 18px;" class="mb-2">Deneme</span><br>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12 p-0 col-lg-4">
          <div style="background: #FFFFFF;box-shadow:0px 3px 10px #ced4da;border-radius: 8px;margin-right: 15px;margin-left: 15px;" class="card-hover">
            <div class="row" style="padding: 10px">
              <div class="col-md-9 col-10">
                <span style="font-weight: 500; font-size: 18px;" class="mb-2">Deneme</span><br>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12 p-0 col-lg-4">
          <div style="background: #FFFFFF;box-shadow:0px 3px 10px #ced4da;border-radius: 8px;margin-right: 15px;margin-left: 15px;" class="card-hover">
            <div class="row" style="padding: 10px">
              <div class="col-md-9 col-10">
                <span style="font-weight: 500; font-size: 18px;" class="mb-2">Deneme</span><br>
              </div>
            </div>
          </div>
        </div>
        -->
      </div>
    </div>
    <div class="col-md-1"></div>
  </div>
</template>

<script>
    import {mapState, mapActions} from "vuex"
    import UserList from "./Users/UserList";
    import ProjectDetails from "./Administration/ProjectDetails";

    export default {
      name: "DashboardPageDetail",
      components: {ProjectDetails, UserList},
      data() {
            return {
                projectId: this.$route.params.projectId,
                projectCode: this.$route.params.code,
                isRed: false
            }

        },

        methods: {
            ...mapActions('projects', ['getProject']),
            async goToRolePerm(value, name, code) {
                this.$router.push({
                    name: 'ProjectDetails',
                    params: {selectedProjectId: parseInt(value), selectedProjectName: name, selectedProjectCode: code}
                });
            },
            goToWebSite(mainRoute) {
                window.open(mainRoute.toString(), '_blank');
            },
          makeRed: function() {
            this.isRed = true;

          }
        },

        computed: {
            ...mapState('projects', ['project']),

        },

        async created() {
            await this.getProject(this.projectId);
        }
    }

</script>

<style scoped>
    .card-hover:hover{
      box-shadow:0px 3px 10px #8d8d95 !important;
    }
    .nav-tabs .nav-link.active{
      color: #D21313FF;
      border-bottom: 1px solid #ced4da;
    }
    .nav-link{
      color: #383838;
    }
    .nav-link:focus, .nav-link:hover {
      color: #56759c;
    }
    .nav-tabs{
      border: unset;
    }
</style>
